import Image from "next/image";
import Link from "next/link";

const Logo = (props) => {
  const { options, isFooter, cdn } = props;
  const logo = options?.logo?.filename_disk;

  if (!logo) return;


  const logoPath = (process.env.CDN_URL || cdn) + logo;

  return (
    <Link href="/">
      <Image
        src={logoPath}
        width="145"
        priority="true"
        height="43"
        alt="Logo"
        className={`${isFooter ? "" : "pl-3"}`}
      />
    </Link>
  );
};

export default Logo;
